import { render, staticRenderFns } from "./CalculadoraDialogShowValores.vue?vue&type=template&id=c0ad1532&scoped=true"
import script from "./CalculadoraDialogShowValores.vue?vue&type=script&lang=ts"
export * from "./CalculadoraDialogShowValores.vue?vue&type=script&lang=ts"
import style0 from "./CalculadoraDialogShowValores.vue?vue&type=style&index=0&id=c0ad1532&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ad1532",
  null
  
)

export default component.exports